/**
 * API Request and Response Types
 */

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum ContentType {
  JSON = "application/json",
  FORM_DATA = "multipart/form-data",
  URL_ENCODED = "application/x-www-form-urlencoded",
}

export type ApiRequestConfig = {
  method?: HttpMethod;
  headers?: Record<string, string>;
  body?: unknown;
  params?: Record<string, string | number | boolean>;
  requiresAuth?: boolean;
  contentType?: ContentType;
  signal?: AbortSignal;
  timeout?: number;
};

export type ApiResponse<T = unknown> = {
  data: T;
  status: number;
  statusText: string;
  headers: Headers;
};

export type ApiError = {
  message: string;
  status: number;
  statusText: string;
  errors?: Record<string, string[]>;
  code?: string;
  /** Parsed error response body, for endpoints that return structured data on error (e.g. 409 matches). */
  data?: unknown;
};

export type PaginatedResponse<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

export type FileUploadConfig = {
  file: File | File[];
  fieldName?: string;
  additionalData?: Record<string, unknown>;
  onProgress?: (progress: number) => void;
};

export enum ApiErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  NOT_FOUND = "NOT_FOUND",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  SERVER_ERROR = "SERVER_ERROR",
  NETWORK_ERROR = "NETWORK_ERROR",
  TIMEOUT_ERROR = "TIMEOUT_ERROR",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
}

